'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /smarthelpnodeweb-ci-5863/workspace/Release_Build/~/smc-extendsession/~/react/react.js
// module id = 1135
// module chunks = 0 1